import { Location, MapDataCache } from "../types.ts";

class CacheManager {
  private cache: MapDataCache = {
    key: null,
    data: null,
    location: null,
  };

  getCacheKey(lat: number, lon: number, distance: number): string {
    return `${lat.toFixed(4)}|${lon.toFixed(4)}|${distance}`;
  }

  isHit(key: string): boolean {
    return this.cache.key === key && this.cache.data !== null;
  }

  get(): MapDataCache {
    return this.cache;
  }

  set(key: string, data: any, location: Location): void {
    this.cache = { key, data, location };
  }

  clear(): void {
    this.cache = { key: null, data: null, location: null };
  }
}

export const cache = new CacheManager();
